<template>
  <div class="app-header">
    <div class="row">
      <list-search @focused="querying = true" @blurred="querying = false"/>
      <transition name="fade">
          <div class="controls" v-show="!querying">
            <editing-toggle/>
            <editing-categories-toggle v-if="editing"/>
            <checked-items-visible-toggle v-else/>
            <sign-out-button/>
          </div>
      </transition>
<!--      <app-menu-toggle/>-->
    </div>
  </div>
</template>
<script>
  import ListSearch from '@/components/listSearch'
  import EditingToggle from '@/components/EditingToggle'
  import checkedItemsVisibleToggle from '@/components/CheckedItemsVisibleToggle'
  import signOutButton from '@/components/SignOutButton'
  import { mapState } from 'vuex'
  import EditingCategoriesToggle from '@/components/EditingCategoriesToggle'

  export default {
    name: 'app-header',
    components: {EditingCategoriesToggle, signOutButton, checkedItemsVisibleToggle, EditingToggle, ListSearch},
    data () {
      return {
        querying: false
      }
    },
    computed: {
      ...mapState(['editing'])
    },
    mounted () {
      this.$root.$on('itemAdded', () => this.querying = false)
    }
  }
</script>
<style scoped lang="sass">
  .app-header
    height: $size-64

    .row
      position: fixed
      z-index: 9
      top: 0
      right: 0
      width: 100%
      padding: $size-12
      background-color: $white
      box-shadow: $shadow
      flex-direction: row

      +horizontal-safe-area
        border-radius: $item-radius
        margin-top: $size-12
        box-shadow: none

        &:after
          content: ''
          +full-size-absolute
          box-shadow: 0 $size-12 0 $white
          transform: scaleY(-1)
          pointer-events: none

          +dark
            box-shadow: 0 $size-12 0 $black-10

      +dark
        background-color: $black

  .controls
    margin-right: $size-12

    > *
      margin: 0 2gem
</style>
